import React from 'react';
import { useGetSessions } from '../../hooks/useChat';
import { useUIStore } from '../../stores/uiStore';
import { formatDistanceToNow } from 'date-fns';
import styles from './Sidebar.module.css';

const Sidebar: React.FC = () => {
  const { data: sessions, isLoading, error } = useGetSessions();
  const { activeSessionId, setActiveSessionId } = useUIStore();
  const { isSidebarOpen, setIsSidebarOpen } = useUIStore();

  const handleSessionClick = (sessionId: string) => {
    setActiveSessionId(sessionId);
    if(window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const formatDate = (dateString: string) => {
    try {
      return formatDistanceToNow(new Date(dateString), { addSuffix: true });
    } catch (error) {
      return 'Invalid date';
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.logo}>
          <img  className={styles.logo_img} src="/assets/imgs/logo_zven_small.png" alt="Logo" />
        </div>
        <div onClick={toggleSidebar} className={styles.mobile}>
          <img className={styles.closeIcon} src="/assets/imgs/close.svg" alt="close_icon" />
        </div>
      </div>

      <div className={styles.threadList}>
        {isLoading && (
          <div className={styles.emptyState}>Loading sessions...</div>
        )}

        {error && (
          <div className={styles.emptyState}>
            Error loading sessions. Please try again.
          </div>
        )}

        {!isLoading && !error && sessions?.length === 0 && (
          <div className={styles.emptyState}>
            No sessions yet. Start a conversation to create one.
          </div>
        )}

        {sessions?.map((session) => (
          <div
            key={session.id}
            className={`${styles.threadItem} ${
              activeSessionId === session.id ? styles.threadItemActive : ''
            }`}
            onClick={() => handleSessionClick(session.id)}
          >
            <div className={styles.threadTitle}>{session.title}</div>
            <div className={styles.threadDate}>
              {formatDate(session.updated_at)}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        © 2025 Svennis — Built with passion and code.
      </div>
    </div>
  );
};

export default Sidebar;